<div class="modal-header">
  <h2 class="modal-title" mat-dialog-title>
    <span *ngIf="data.config" trans>Update twitch widget</span>
    <span *ngIf="!data.config">Add twitch widget</span>
  </h2>
  <button type="button" (click)="close()" class="close-button no-style" tabindex="-1">
    <mat-icon svgIcon="close"></mat-icon>
  </button>
</div>

<form (ngSubmit)="createOrUpdate()" [formGroup]="form" ngNativeValidate>
  <div mat-dialog-content>
    <div class="input-container">
      <label for="twitch-widget-url" trans>Twitch Url</label>
      <input
        type="url"
        id="twitch-widget-url"
        formControlName="url"
        placeholder="https://www.twitch.tv/kasparovchess"
        cdkFocusInitial
        required
      />
      <div class="error" *ngIf="(errors$ | async).url as error" trans>{{ error }}</div>
    </div>
  </div>

  <div class="buttons right" mat-dialog-actions>
    <button (click)="close()" type="button" mat-button class="button cancel cancel-button" trans>
      Cancel
    </button>
    <button
      type="submit"
      mat-raised-button
      color="accent"
      [disabled]="editor.loading$ | async"
      class="button primary submit-button"
    >
      <span *ngIf="data.config" trans>Update</span>
      <span *ngIf="!data.config" trans>Add</span>
    </button>
  </div>
</form>
